import { useMutation } from "@tanstack/react-query";
import ApiClient from "../../../api/ApiClient";
import { Category } from "../data/Category";
import { AxiosError } from "axios";

async function post(name: string): Promise<Category> {
    try {
        const response = await ApiClient({ url: "categories", method: "POST", data: { name: name } });
        if (response.status === 201) {
            return response.data;
        }
        throw new Error(response.data);
    } catch (error) {
        throw new Error(error instanceof AxiosError ? error.response?.data?.error : "An unexpected error occurred");
    }
}

export function usePostCategoryMutation(onSuccess: (data: Category) => void, onError: (error: Error) => void) {
    return useMutation<Category, Error, string>({
        mutationKey: ["post-category"],
        mutationFn: post,
        onSuccess: onSuccess,
        onError: onError
    });
}